import { ErrorHandler, NgModule } from '@angular/core';
import { AppComponent } from './app/app.component';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BlueCityFiltersComponent } from './app/components/blue-city-filters/blue-city-filters.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    DropdownFilterComponent,
    FilterContainerModule,
    MultiSelectFilterComponent,
    TextFilterComponent,
} from '@ui/shared/ui-filter';
import { ListViewModule } from '@ui/shared/feature-list';
import { FilterState, SimpleActiveFilterService } from '@ui/shared/domain-filter';
import {
    AbstractMapIconsService,
    AbstractSvgIconService,
    MapIconsService,
    SvgIconService,
} from '@ui/shared/domain-api';
import { apiConfigurationFactory, Configuration } from '@ui/shared/util-api';
import { AbstractEnvironmentService, ConfigModule, EnvironmentService } from '@ui/shared/domain-config';
import { BlueCityItemDetailsComponent } from './app/components/blue-city-item-details/blue-city-item-details.component';
import { provideTheme } from '@ui/theme';
import { bugsnagErrorHandlerFactory } from '@ui/shared/feature-config';

@NgModule({
    declarations: [
        BlueCityFiltersComponent,
        AppComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        BrowserModule,
        ConfigModule,
        ListViewModule,
        FilterContainerModule,
        DropdownFilterComponent,
        MultiSelectFilterComponent,
        TextFilterComponent,
        BlueCityItemDetailsComponent,
    ],
    providers: [
        {
            provide: FilterState,
            useClass: SimpleActiveFilterService,
        },
        {
            provide: AbstractMapIconsService,
            useClass: MapIconsService,
        },
        {
            provide: AbstractSvgIconService,
            useClass: SvgIconService,
        },
        {
            provide: AbstractEnvironmentService,
            useClass: EnvironmentService,
        },
        {
            provide: Configuration,
            useFactory: apiConfigurationFactory,
            deps: [AbstractEnvironmentService],
        },
        {
            provide: ErrorHandler,
            useFactory: bugsnagErrorHandlerFactory,
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideTheme(),
    ],
})
export class BlueCityModule {
}
